import Vue from 'vue';

import '@frontend/engagebutton/css/main.scss';

import initializeSentry from '@frontend/shared/monitoring.js';
initializeSentry(Vue);

import InstitutionalReport from './components/InstitutionalReport.vue';
import DynamicQuestionnaire from '@frontend/ui/views/questionnaire/DynamicQuestionnaire.vue';


if (document.getElementById('institutional-report')) {
  const institutionalReport = new Vue({
    el: '#institutional-report',
    template: '<InstitutionalReport/>',
    data() {
      return {
        STATIC_ROOT: '',
      };
    },
    components: { InstitutionalReport },
    render: h => h(InstitutionalReport),
  });
}
if (document.getElementById('dynamic-questionnaire')) {
  // Hacky way of passing props from django generated html...
  const el = document.getElementById('dynamic-questionnaire');
  const dynamicQuestionnaire = new Vue({
    el: '#dynamic-questionnaire',
    template: '<DynamicQuestionnaire/>',
    data() {
      return {
        STATIC_ROOT: '',
      };
    },
    props: ['mode', 'questionnaireType'],
    components: { DynamicQuestionnaire },
    render: h => h(DynamicQuestionnaire, { props: {
      mode: el.dataset.mode,
      clientId: el.dataset.clientid,
      resultsRedirect: true,
      sendNotifications: true,
      questionnaireType: el.dataset.questionnairetype,
    } }),
  });
}

if (document.getElementById('sinewave-report')) {
  draw();
}
